import { gql } from '@apollo/client'
import { Heading } from '@farol-ds/react'

import { PlanOfferSimplifiedCard } from '../plan-offer-simplified-card'
import {
  TwoOffersLockContent_OfferLockDataFragment,
  TwoOffersLockContent_ViewerFragment,
} from './__generated__/two-offers-lock-content.graphql'
import styles from './two-offers-lock.module.scss'

export interface TwoOffersLockContentProps {
  offerLockData: TwoOffersLockContent_OfferLockDataFragment
  viewer: TwoOffersLockContent_ViewerFragment
}

export function TwoOffersLockContent({ offerLockData, viewer }: TwoOffersLockContentProps) {
  const header = offerLockData.header
  const title = header.title || ''
  const { body } = offerLockData || {}
  const { cards } = body || {}

  return (
    <>
      <Heading className={styles['two-offers-lock-title']} size="lg" asChild>
        <h3>{title}</h3>
      </Heading>
      <div className={styles['two-offers-lock-cards']}>
        {cards.map((card, index) => (
          <PlanOfferSimplifiedCard
            offerLockCard={card}
            viewer={viewer}
            key={`plan-offer-card-${index}`}
            className={styles['two-offers-lock-cards-card']}
          />
        ))}
      </div>
    </>
  )
}

TwoOffersLockContent.fragments = {
  offerLockData: gql`
    fragment TwoOffersLockContent_offerLockData on OfferLockData {
      header {
        title
      }
      body {
        ...PlanOfferSimplifiedCard_offerLockBody
        cards {
          ...PlanOfferSimplifiedCard_offerLockCard
        }
      }
    }
    ${PlanOfferSimplifiedCard.fragments.offerLockCard}
    ${PlanOfferSimplifiedCard.fragments.offerLockBody}
  `,
  viewer: gql`
    fragment TwoOffersLockContent_viewer on Profile {
      ...PlanOfferSimplifiedCard_viewer
    }
    ${PlanOfferSimplifiedCard.fragments.viewer}
  `,
}
